interface Props {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'center' }: Props) {
  const alignCls = align === 'center' ? 'mx-auto text-center items-center' : 'text-left items-start';
  return (
    <div className={`mb-8 flex max-w-2xl flex-col md:mb-10 ${alignCls}`}>
      {eyebrow && (
        <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
          <i className="ri-sparkling-2-line" />
          {eyebrow}
        </span>
      )}
      <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">{title}</h2>
      {desc && <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
    </div>
  );
}